import { Link } from "react-router-dom";
import { MessageSquareText, Cookie } from "lucide-react";
import logoBranca from "@/assets/logo-branca.webp";
import { openCookieSettings } from "@/hooks/useCookieConsent";

const LandingFooter = () => (
  <>
    <footer className="py-12 border-t border-border/30">
      <div className="container mx-auto px-5 sm:px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left">
          <div className="flex flex-col items-center md:items-start">
            <img src={logoBranca} alt="12 Personas de Estilo" className="h-6 w-auto" />
            <span className="text-[10px] text-muted-foreground mt-1">Portal das 12 Personas de Estilo</span>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-3 text-muted-foreground text-sm">
            <Link to="/termos-de-uso" className="hover:text-foreground transition-smooth">Termos de Uso</Link>
            <Link to="/privacidade" className="hover:text-foreground transition-smooth">Privacidade</Link>
            <Link to="/incidentes-lgpd" className="hover:text-foreground transition-smooth">Incidentes LGPD</Link>
            <button onClick={openCookieSettings} className="hover:text-foreground transition-smooth inline-flex items-center gap-1">
              <Cookie className="w-3.5 h-3.5" /> Cookies
            </button>
            <a href="https://hallal.com.br/" target="_blank" rel="noopener noreferrer" className="hover:text-foreground transition-smooth">
              Contato
            </a>
          </div>

          <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} Leonardo Hallal. Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>

    {/* Floating Help Button */}
    <a
      href="#faq"
      aria-label="Precisa de ajuda?"
      className="fixed right-4 sm:right-6 bottom-[calc(env(safe-area-inset-bottom,0px)+1rem)] sm:bottom-6 z-50 flex items-center gap-2 bg-primary text-primary-foreground px-4 sm:px-5 py-3 rounded-full shadow-lg hover:scale-105 transition-all hover:shadow-glow-strong group"
    >
      <MessageSquareText className="w-5 h-5 shrink-0" />
      <span className="hidden sm:inline text-sm font-semibold">Precisa de ajuda?</span>
    </a>
  </>
);

export default LandingFooter;
